import { React, useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { PAGE_ROUTE, API_URL } from '../shared/constant';
import TableComponent from '../../admin/shared/table';
import LoaderComponent from '../../admin/shared/loader';
import axios from 'axios';

export default function CatalogueFormComponent() {

    const columns = [{
        field: 'name',
        lable: 'Name'
    }, {
        field: 'category_name',
        lable: 'Category'
    }, {
        field: 'pdf_file_name',
        lable: "Pdf File",
        isLink: true,
        link: 'pdf_url'
    }];

    const [isLoading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [isRecall, setIsRecall] = useState(false);

    useEffect(() => {
        getCatlogue();
    }, []);

    useEffect(() => {
        isRecall && getCatlogue();
    }, [isRecall]);

    const getCatlogue = () => {
        setLoading(true);
        axios.post(API_URL.ADMIN_PDF_LIST, {}).then(res => {
            setData(res.data);
            setIsRecall(false);
            setLoading(false);
        }, error => {
            setLoading(false);
        })
    };

    const onDelete = (item) => {
        let id = item.id;
        axios.post(API_URL.ADMIN_PDF_DELETE + id).then((response) => {
            setIsRecall(true);
        });
    };

    const onEdit = (item) => {
        navigate(PAGE_ROUTE.ADMIN_CATALOGUE_EDIT + item.id, { replace: true });
    };

    return (
        <div>
            <div className='card'>
                <div className='card-body'>
                    <h4 className='card-title'>Catalogue
                        <NavLink to={PAGE_ROUTE.ADMIN_CATALOGUE_CREATE} className="btn btn-primary">
                            Add
                        </NavLink>
                    </h4>
                    {
                        isLoading && <LoaderComponent height={80} width={80}></LoaderComponent>
                    }
                    {
                        !isLoading && <div className="table-responsive">
                            <div className='table-responsive'>
                                <TableComponent
                                    columns={columns}
                                    data={data}
                                    onDelete={onDelete}
                                    onEdit={onEdit}>
                                </TableComponent>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}